import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_EXPERIMENTS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Experiments = lazy(() =>
  import('../../../screens/Experiments')
    .then(module => ({default: module.Experiments})));

const ExperimentsNavigation = [
  {
    path: ROUTE_EXPERIMENTS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Experiments />
      </Suspense>
    ),
  },
];

export default ExperimentsNavigation;
